import { AttendanceStatus, CertificateResultStatus } from '../types/OpenClass';
import { SessionAttendeeStatus } from './sessionAttendees';

// Listed once and rendered both as the per-row popover and as the bulk menu.
export type StatusAction = {
  key: string;
  status: SessionAttendeeStatus;
  field: 'attendanceStatus' | 'certificateResultStatus';
  value: AttendanceStatus | CertificateResultStatus;
};

export const statusActions: StatusAction[] = [
  {
    key: 'present',
    status: 'present',
    field: 'attendanceStatus',
    value: 'present',
  },
  {
    key: 'not_present',
    status: 'notPresent',
    field: 'attendanceStatus',
    value: 'not_present',
  },
  {
    key: 'passed',
    status: 'passed',
    field: 'certificateResultStatus',
    value: 'passed',
  },
  {
    key: 'failed',
    status: 'failed',
    field: 'certificateResultStatus',
    value: 'failed',
  },
  {
    key: 'clear',
    status: 'notRecorded',
    field: 'certificateResultStatus',
    value: 'not_recorded',
  },
];

const eligibleForFinalPass = (attendee: {
  attendedAllSessions: boolean;
  failedSession: boolean;
}) => attendee.attendedAllSessions && !attendee.failedSession;

export const splitByPassEligibility = <
  T extends { attendedAllSessions: boolean; failedSession: boolean },
>(
  action: StatusAction,
  attendees: T[],
): { eligible: T[]; skipped: T[] } =>
  action.key === 'passed'
    ? {
        eligible: attendees.filter(eligibleForFinalPass),
        skipped: attendees.filter(
          (attendee) => !eligibleForFinalPass(attendee),
        ),
      }
    : { eligible: attendees, skipped: [] };

export const splitByCertificateIssued = <
  T extends { certificateIssued: boolean },
>(
  attendees: T[],
): { writable: T[]; locked: T[] } => ({
  writable: attendees.filter(({ certificateIssued }) => !certificateIssued),
  locked: attendees.filter(({ certificateIssued }) => certificateIssued),
});
